export default __webpack_public_path__ + "static/media/eshan.e94572dd.jpg";